import { Component, Input, OnInit } from '@angular/core';
import { NavItem } from '../external-content-wrapper/external-content-wrapper.component'

@Component({
  selector: 'external-content-nav-dropdown',
  templateUrl: './external-content-nav-dropdown.component.html',
  styleUrls: ['./external-content-nav-dropdown.component.scss']
})
export class ExternalContentNavDropdownComponent implements OnInit {
  @Input() isSidebarItem: boolean = true;
  // dropdown items are required for this component, but not all NavItems, hence the required pick
  @Input() navItem: NavItem

  constructor() { }

  ngOnInit(): void {
  }

  showDesktopDropdown(dropdown: HTMLDetailsElement, isFocusHovered: boolean) {
    if(this.isSidebarItem) {
      return;
    }

    // focus within allows keyboard navigation to work correctly
    dropdown.open = dropdown.matches(':focus-within') || isFocusHovered;
  }
}
